(() => {
  if (!document.body.classList.contains('nh-retail')) return;
  // Card quick-add is isolated from Empire's product-page form and retains native POST without JS.
  document.addEventListener('submit', async event => {
    const form=event.target;
    if(!form.matches('.nh-product-form')) return;
    event.preventDefault();
    if(form.dataset.busy==='true') return;
    const button=form.querySelector('button[type="submit"]');
    const status=form.querySelector('.nh-form-status');
    const label=button.innerHTML;
    form.dataset.busy='true';button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Lægger i kurv…';status.textContent='';
    const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),20000);
    const cartLink=()=>{const link=document.createElement('a');link.href=`${window.Shopify?.routes?.root||'/'}cart`;link.textContent='Se kurv';return link;};
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal:controller.signal});
      const data=await response.json();
      if(!response.ok){status.textContent=data.description||'Varen kunne ikke lægges i kurven. Prøv en anden størrelse.';return;}
      status.append(document.createTextNode('Lagt i kurven. '),cartLink());
      document.dispatchEvent(new CustomEvent('nh:cart-updated'));
      // Add is already confirmed. Opening the drawer must never add again.
      if (window.NHCartDrawer) window.NHCartDrawer.open({refresh:true, trigger:button});
    }catch{
      status.append(document.createTextNode('Vi kunne ikke bekræfte tilføjelsen. Kontrollér kurven, før du prøver igen. '),cartLink());
    }finally{
      clearTimeout(timeout);form.dataset.busy='false';button.disabled=false;button.removeAttribute('aria-busy');button.innerHTML=label;
    }
  });
  // Resolve tag URLs before interaction, including keyboard and open-in-new-tab.
  document.querySelectorAll('[data-nh-tag-link] a').forEach(link => {
    const target = new URL(link.href);
    const query = new URLSearchParams(location.search);
    query.delete('page');
    target.search = query.toString();
    link.href = target.href;
  });
  // Cache only this guest's public listing, never cart, customer or B2B content.
  // One entry, ten minutes, at most 60 cards / 400k characters. The URL remains
  // the original listing URL: refresh stays server-native, Back restores the view.
  const prepareListingCache = listing => {
    const key = 'nh-public-listing-v1';
    const ttl = 10 * 60 * 1000;
    const limit = 400000;
    const grid = listing.querySelector('[data-nh-product-grid]');
    if (listing.dataset.publicCache !== 'true' || !grid) return null;
    const context = JSON.stringify([location.href, listing.dataset.sourceCount, listing.dataset.market, listing.dataset.currency]);
    let storage;
    let previous;
    try {
      storage = window.sessionStorage;
      storage.setItem(`${key}-probe`, '1'); storage.removeItem(`${key}-probe`);
      const raw = storage.getItem(key);
      if (raw && raw.length <= limit) previous = JSON.parse(raw);
    } catch (_) { return null; }
    const isBack = window.performance?.getEntriesByType('navigation')[0]?.type === 'back_forward';
    const visit = isBack && history.state?.nhListingVisit || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    try { history.replaceState({ ...(history.state || {}), nhListingVisit: visit }, '', location.href); } catch (_) { return null; }
    let restored = false;
    const valid = previous && isBack && previous.visit === visit && previous.context === context &&
      Date.now() - previous.savedAt >= 0 && Date.now() - previous.savedAt < ttl &&
      typeof previous.grid === 'string' && typeof previous.pagination === 'string' &&
      typeof previous.status === 'string' && Number.isFinite(previous.scroll) && previous.scroll >= 0 &&
      Number.isInteger(previous.cards) && previous.cards > 0 && previous.cards <= 60;
    if (valid) {
      const parsed = new DOMParser().parseFromString(previous.grid, 'text/html');
      const cards = [...parsed.body.children];
      const parsedPagination = new DOMParser().parseFromString(previous.pagination, 'text/html');
      const pagination = parsedPagination.querySelector('[data-nh-pagination]');
      if (cards.length === previous.cards && cards.every(card => card.matches('li') && card.children.length === 1 && card.firstElementChild.matches('article.nh-card')) &&
          !parsed.querySelector('script,iframe,object') && !parsedPagination.querySelector('script,iframe,object')) {
        // A navigation can interrupt a pending quick-add or load request. Never
        // restore a permanently disabled control from that transient snapshot.
        cards.forEach(card => card.querySelectorAll('.nh-product-form[data-busy="true"]').forEach(form => {
          form.removeAttribute('data-busy');
          const button = form.querySelector('button[type="submit"]');
          if (button) {
            button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = 'Læg i kurv';
          }
          const formStatus = form.querySelector('.nh-form-status');
          if (formStatus) formStatus.textContent = 'Kontrollér kurven, før du tilføjer igen.';
        }));
        const loadMore = pagination?.querySelector('[data-nh-load-more]');
        if (loadMore) { loadMore.removeAttribute('aria-disabled'); loadMore.textContent = 'Vis flere produkter'; }
        grid.replaceChildren(...cards);
        const currentPagination = listing.querySelector('[data-nh-pagination]');
        if (pagination && currentPagination) currentPagination.replaceWith(pagination);
        else if (!pagination) currentPagination?.remove();
        if (cards.length) listing.querySelector('[data-nh-empty-page]')?.remove();
        const status = listing.querySelector('[data-nh-list-status]');
        if (status) status.textContent = previous.status;
        restored = true;
      }
    }
    let active = true;
    const save = () => {
      if (!active) return false;
      try {
        const record = {
          visit, context, savedAt: Date.now(), cards: grid.children.length,
          grid: grid.innerHTML,
          pagination: listing.querySelector('[data-nh-pagination]')?.outerHTML || '',
          status: listing.querySelector('[data-nh-list-status]')?.textContent || '',
          scroll: Math.max(0, window.scrollY),
        };
        const serialized = JSON.stringify(record);
        if (record.cards > 60 || serialized.length > limit) throw new Error('Listing cache limit');
        storage.setItem(key, serialized);
        return true;
      } catch (_) {
        active = false;
        try { storage.removeItem(key); } catch (_) { /* Storage can be blocked. */ }
        listing.classList.remove('nh-list-enhanced');
        return false;
      }
    };
    window.addEventListener('pagehide', save);
    window.addEventListener('pageshow', event => {
      if (event.persisted || !restored) return; // Native bfcache retains DOM and scroll.
      window.requestAnimationFrame(() => window.scrollTo({ top: previous.scroll, behavior: 'instant' }));
    });
    return { save };
  };
  document.querySelectorAll('[data-nh-listing]').forEach(listing => {
    listing.nhListingCache = prepareListingCache(listing);
    if (listing.nhListingCache) listing.classList.add('nh-list-enhanced');
    const toggle=listing.querySelector('[data-nh-filter-toggle]');
    const panel=listing.querySelector('.nh-filters');
    if(toggle && !toggle.dataset.nhFilterReady && panel && matchMedia('(max-width:767px)').matches){toggle.setAttribute('aria-expanded','false');panel.dataset.collapsed='true';}
    listing.querySelector('[data-nh-sort]')?.addEventListener('change',event=>event.target.form.requestSubmit());
    listing.querySelectorAll('[data-nh-price-range]').forEach(button=>{
      const min=listing.querySelector('[name="filter.v.price.gte"]');
      const max=listing.querySelector('[name="filter.v.price.lte"]');
      const values=button.dataset.nhPriceRange.split(',');
      const selected=min && max && (min.value||'0')===values[0] && max.value===values[1];
      button.setAttribute('aria-pressed',String(Boolean(selected)));
      button.addEventListener('click',()=>{if(!min||!max)return;min.value=selected?'':values[0];max.value=selected?'':values[1];min.form.requestSubmit();});
    });
  });
  // Native GET forms are the baseline. Progressive loading never changes filtering semantics.
  document.addEventListener('click', async (event) => {
    const tagLink=event.target.closest('[data-nh-tag-link] a');
    if(tagLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey){
      const target=new URL(tagLink.href);
      const query=new URLSearchParams(location.search);query.delete('page');
      target.search=query.toString();tagLink.href=target.href;
    }
    const filterToggle = event.target.closest('[data-nh-filter-toggle]');
    if (filterToggle && !filterToggle.dataset.nhFilterReady) {
      const panel = document.getElementById(filterToggle.getAttribute('aria-controls'));
      if (!panel) return;
      const expanded = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', String(!expanded));
      panel.dataset.collapsed = String(expanded);
    }
    const link = event.target.closest('[data-nh-load-more]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const listing = link.closest('[data-nh-listing]');
    if (!listing) return;
    if (!listing.nhListingCache || !listing.classList.contains('nh-list-enhanced')) return;
    if (listing.querySelector('[data-nh-product-grid]').children.length >= 60) {
      listing.classList.remove('nh-list-enhanced');
      return; // Above the bounded cache limit, follow the native next-page link.
    }
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    const status = listing.querySelector('[data-nh-list-status]');
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Henter produkter…';
    const abort = new AbortController();
    const timeout = window.setTimeout(() => abort.abort(), 15000);
    try {
      const response = await fetch(link.href, {signal: abort.signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('Failed response');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = parsed.querySelector('[data-nh-product-grid]');
      if (!nextGrid) throw new Error('Missing products');
      const nextProducts = [...nextGrid.children];
      const grid = listing.querySelector('[data-nh-product-grid]');
      const first = nextProducts[0];
      grid.append(...nextProducts);
      if (nextProducts.length) listing.querySelector('[data-nh-empty-page]')?.remove();
      const pagination = listing.querySelector('[data-nh-pagination]');
      const nextPagination = parsed.querySelector('[data-nh-pagination]');
      if (nextPagination) pagination.replaceWith(nextPagination); else pagination.remove();
      status.textContent = `${nextProducts.length} flere produkter er indlæst.`;
      listing.nhListingCache.save();
      const focusTarget = first?.querySelector('h3 a, a:not([aria-hidden="true"])');
      focusTarget?.focus({preventScroll:true});
    } catch {
      listing.classList.remove('nh-list-enhanced');
      status.textContent = 'Produkterne kunne ikke hentes. Prøv igen, eller vælg et sidenummer.';
      link.setAttribute('aria-disabled','false');
      link.textContent = 'Prøv igen';
    } finally { window.clearTimeout(timeout); }
  });
})();
